import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "../../store/authStore";

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** Login path for redirect when unauthenticated. Default: /login, or /portal/login when path starts with /portal (Story 7-1). */
  loginPath?: string;
}

export function ProtectedRoute({ children, loginPath }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuthStore();
  const location = useLocation();
  const redirectTo =
    loginPath ?? (location.pathname.startsWith("/portal") ? "/portal/login" : "/login");

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div
          className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"
          role="status"
          aria-label="Loading"
        ></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={redirectTo} state={{ from: { pathname: location.pathname } }} replace />;
  }

  // Story 7-2 (AC 9): customers may access portal and account settings; other routes → /portal with access denied
  const path = location.pathname;
  const customerAllowed =
    path.startsWith("/portal") ||
    path.startsWith("/settings") ||
    path === "/orders" ||
    path.startsWith("/orders/") ||
    path === "/setup-2fa-required";
  if (user?.role === "customer" && !customerAllowed) {
    return <Navigate to="/portal" state={{ message: "Access denied" }} replace />;
  }

  return <>{children}</>;
}
